module.exports = __webpack_public_path__ + "media/entities/2201-d477ffc2.png";